var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusAlertOutlined4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 21,
    height: 21,
    fill: "#db1616"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#35ac25",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1879",
    "data-name": "Groupe 1879",
    transform: "translate(1 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_594",
    "data-name": "Trac\\xE9 594",
    d: "M4.5,16A1.5,1.5,0,1,0,3,14.5,1.5,1.5,0,0,0,4.5,16",
    fill: "#db1616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_595",
    "data-name": "Trac\\xE9 595",
    d: "M11.5,16A1.5,1.5,0,1,0,10,14.5,1.5,1.5,0,0,0,11.5,16",
    fill: "#db1616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_596",
    "data-name": "Trac\\xE9 596",
    d: "M2,10V7H9.29A6.908,6.908,0,0,1,9,5H2.43c.83-.71,2.98-1.09,6.65-.98a7.047,7.047,0,0,1,.59-1.99C.97,1.67,0,4.02,0,6v9.5a3.464,3.464,0,0,0,1,2.44V20a1,1,0,0,0,1,1H3a1,1,0,0,0,1-1V19h8v1a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V17.94a3.464,3.464,0,0,0,1-2.44V12a6.935,6.935,0,0,1-4.89-2Zm12,5a2.006,2.006,0,0,1-2,2H4a2.006,2.006,0,0,1-2-2V12H14Z",
    fill: "#db1616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_597",
    "data-name": "Trac\\xE9 597",
    d: "M16,0a5,5,0,1,0,5,5,5,5,0,0,0-5-5m.5,8h-1V7h1Zm0-2h-1V2h1Z",
    fill: "#db1616"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusAlertOutlined4);
export default __webpack_public_path__ + "static/media/BusAlertOutlined-4.db84817d36d5d8ffb2ba675bd9232327.svg";
export { ForwardRef as ReactComponent };